'use strict';
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/twilsock/node_modules/core-js/internals/iterators.js
// module id = 819
// module chunks = 25